<div class="group" *ngFor="let item of items; let i = index">
  <h2>Type {{i + 1 | number:'2.0'}}</h2>

  <app-diagram [splitters]="item.splitters" [internal]="item.internal" [boxes]="item.boxes"></app-diagram>

  <mat-divider></mat-divider>
</div>
